export default __webpack_public_path__ + "static/media/gray-star.4fb37ff3.svg";